// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { variantGridStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsVariantSwatchGrid";
import { css } from "styled-components";

variantGridStyles.labelText = {
    variant: "h6",
    css: css`
        margin: 0;
    `,
};

variantGridStyles.link = {
    typographyProps: {
        variant: "h6",
        css: css`
            margin: 0;
        `,
    },
    css: css`
        margin: 0;
    `,
};
